<div class="layout-row layout-align-start-center full-height gap-5">

  <div class="layout-row gap-5 text-ellipsis">
    <app-bringoz-tag *ngFor="let tag of viewTags; let last = last"
                     [name]="tag.name"
                     [backgroundColor]="tag.color"
                     [description]="hideDescription ? tag.description: undefined">
    </app-bringoz-tag>
  </div>

  <div *ngIf="extraTags?.length" class="counter-container" [ngbTooltip]="extraTagsTooltip" openDelay="300" triggers="hover">
    <span>+{{extraTags?.length}}</span>
    <ng-template #extraTagsTooltip>
      <div class="tooltip-content layout-column gap-5">
        <div class="layout-row" *ngFor="let tag of extraTags">
          <app-bringoz-tag [name]="tag.name" [backgroundColor]="tag.color"></app-bringoz-tag>
        </div>
      </div>
    </ng-template>
  </div>

</div>


